export {screenTiny, screenXxs, screenXs, screenSm, screenMd, screenLg, screenXlg} from './media-queries';

export const BreakPointsTypes = {
    Tiny: 'Tiny',
    Xxs: 'Xxs',
    Xs: 'Xs',
    Sm: 'Sm',
    Md: 'Md',
    Lg: 'Lg',
    Xl: 'Xl',
};

export const BreakPointsValues = {
    Tiny: 359,
    Xxs: 479,
    Xs: 767,
    Sm: 991,
    Md: 1199,
    Lg: 1599,
    Xl: Infinity,
};
